const UndoTrashIcon = (props: any) => {
  return (
    <div>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.3699 5.9291H3.63006C3.55344 5.9291 3.49133 5.86699 3.49133 5.79037V3.61696C3.49133 3.54035 3.55344 3.47823 3.63006 3.47823H7.0104C7.03755 3.47823 7.06411 3.47026 7.08678 3.45531L9.19069 2.06763C9.21335 2.05268 9.23991 2.04471 9.26707 2.04471H15.2875C15.3149 2.04471 15.3416 2.05282 15.3644 2.06801L17.4448 3.45493C17.4676 3.47013 17.4944 3.47823 17.5218 3.47823H20.3699C20.4466 3.47823 20.5087 3.54035 20.5087 3.61696V5.79037C20.5087 5.86699 20.4466 5.9291 20.3699 5.9291Z"
          stroke={props.color || "#4E4E4E"}
          stroke-width="1.38728"
        />
        <path
          d="M18.7861 8.14874H5.21386C5.13725 8.14874 5.07513 8.20816 5.07513 8.28478V20.9117C5.07513 21.8551 6.30057 22.7615 7.04045 22.7615C10.0694 22.8539 16.3676 22.9834 17.3295 22.7615C18.2815 22.5417 18.7836 21.4582 18.9207 20.9279C18.9236 20.9169 18.9248 20.906 18.9248 20.8947V8.28747C18.9248 8.21085 18.8627 8.14874 18.7861 8.14874Z"
          stroke={props.color || "#4E4E4E"}
          stroke-width="1.38728"
        />
        <path
          d="M13.5819 19.3484H10.9884C10.9168 19.3484 10.8587 19.2903 10.8587 19.2187V15.6958C10.8587 15.6242 10.8007 15.5661 10.729 15.5661H9.29578C9.18279 15.5661 9.12385 15.4317 9.2004 15.3486L12.1885 12.1049C12.2403 12.0487 12.3293 12.0493 12.3804 12.1062L15.2899 15.3499C15.3648 15.4334 15.3055 15.5661 15.1934 15.5661H13.8413C13.7697 15.5661 13.7116 15.6242 13.7116 15.6958V19.2187C13.7116 19.2903 13.6536 19.3484 13.5819 19.3484Z"
          stroke={props.color || "#4E4E4E"}
          stroke-width="1.08065"
        />
      </svg>
    </div>
  );
};

export default UndoTrashIcon;
